<template>
    <ul v-if="data.children && data.children.length > 0" class="mb-0">
        <li v-for="(child, indexC) in data.children" :key="indexC">
            <div class="parameter-cnt">
                <div class="parameter-info">
                    <span class="parameter-badge">{{ child.name }}</span>
                    <span class="parameter-badge code">{{ child.code }}</span> 
                    <span class="parameter-badge mu">{{ child.mu }}</span>
                </div>
                <font-awesome-icon class="update-icon" icon="cogs" @click="openEditParameterModal(child)" />
            </div>
            
            <ParameterTreeNode :data="child" @open-edit-parameter-modal="openEditParameterModal" />
        </li>
    </ul>
</template>

<script>
export default {
    name: "ParameterTreeNode",
    props: ["data"],
    methods: {
      openEditParameterModal(child) {
            this.$emit('open-edit-parameter-modal', child);
        },
    }
}
</script>

<style scoped>
.update-icon {
    align-self: center;
    cursor: pointer;
}
.parameter-cnt {
  font-size: 12px;
  margin-bottom: 0.25rem;
  background: #f0f0f0;
  display: flex;
  justify-content: space-between;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 10px 12px;
  white-space: nowrap;
  max-width: 400px;
}
.parameter-info {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
}
.parameter-badge {
  background: #fff;
  color: #000;
  padding: 1px 4px;
  border-radius: 5px;
}
.code {
  background: #666;
  color: #fff;
  margin: 0 5px;
}
.mu {
  background: #b3b3b3;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Sites/Parameters/ParameterTreeNode.vue